(function ($) {
    'use strict';
  
    $.popup = function (popupSelector = '#globalPopup', overlaySelector = '#popupOverlay') {
      const $popup = $(popupSelector);
      const $overlay = $(overlaySelector);
  
      const isMobile = () => window.innerWidth <= 768;
  
      const Fn = function () {
        this.open = function (title) {
          if (title !== null) {
            $('#globalPopup').find('h5').html(title);
          }
          $overlay.removeClass('d-none');
          $popup.removeClass('d-none');
           // Désactiver le scroll sur le body
          $('body').addClass('overflow-hidden-scroll');
          $('body').css('overflow', 'hidden');
  
          setTimeout(() => {
            if (isMobile()) {
              $popup.addClass('show-mobile').removeClass('hide-mobile');
            } else {
              $popup.addClass('show-desktop').removeClass('hide-desktop');
            }
          }, 10);
        };

        // Check if the popup is open
        this.isOpen = function () {
          return !$popup.hasClass('d-none');
        };
                  
  
        this.close = function () {
          $overlay.addClass('d-none');
          // Réactiver le scroll sur le body
          $('body').removeClass('overflow-hidden-scroll');
          $('body').css('overflow', 'auto');
          if (isMobile()) {
            $popup.removeClass('show-mobile').addClass('hide-mobile');
          } else {
            $popup.removeClass('show-desktop').addClass('hide-desktop');
          }

          $('.skp-pdp .js-backInstock').attr('disabled', false);

          setTimeout(() => {
            $popup.addClass('d-none');
          }, 400);
        };

        
      };
  
      return new Fn();
    };


    const globalPopup = $.popup();
    $('#openPopup').on('click', function () {
      globalPopup.open();
    });
  
    $('#closePopup, #popupOverlay').on('click', function () {
      globalPopup.close();
    });

  })(jQuery);

(function (){
  var s = window.innerWidth - document.documentElement.offsetWidth;
  document.documentElement.style.setProperty('--scrollbar-width', s + 'px');
})();
  